export default __webpack_public_path__ + "static/media/img1.106cb077.png";